
import { FlightService } from '@/utils/api/flight';
import { ElMessage } from 'element-plus';
import { defineComponent, ref, watch, onMounted } from 'vue';
export default defineComponent({
  name: 'AirportPicker',
  props: {
    airport: String,
  },
  setup(props, context) {
    const airportList = ref([]);
    onMounted(() => {
      getAirports();
    });
    const getAirports = () => {
      FlightService.selectAllAirport()
        .then((res) => {
          if (res.status === 200) {
            (airportList as any).value = res.data;
          } else {
            ElMessage('获取机场失败');
          }
        })
        .catch();
    };
    const pickedAirport = ref(props.airport);
    const change = () => {
      console.log('pickedAirport.value: ', pickedAirport.value);
      context.emit('update:airport', pickedAirport.value);
    };
    return {
      pickedAirport,
      airportList,
      change,
    };
  },
});
